import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconComponent } from '@app/components/icon/icon.component';
import { MainMenuButton } from '@app/models/elements/main-menu-button';
import { RouterService } from '@app/services/router.service';
import { environment } from '@environments/environment';

@Component({
	selector: 'app-main-menu-button',
	standalone: true,
	imports: [RouterLink, IconComponent],
	templateUrl: './main-menu-button.component.html',
	styleUrl: './main-menu-button.component.css',
})
export class MainMenuButtonComponent {
	environment = environment;
	@Input() link: MainMenuButton = {} as MainMenuButton;

	constructor(public routerService: RouterService) {}
}
